/* 🤖 this file was generated by svg-to-ts */
export const svgSearch: {
    name: "search";
    data: string;
} = {
    name: "search",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__search" viewBox="0 0 20 20"><path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" d="m16.883 16.883-2.488-2.487M9.587 16.056c4.14 0 6.47-2.329 6.47-6.469 0-4.14-2.33-6.47-6.47-6.47s-6.47 2.33-6.47 6.47 2.33 6.47 6.47 6.47z" clip-rule="evenodd"/></symbol></svg>`,
};
